// Copyright (c) 2022, 2023 Visual Intelligence LP. All rights reserved.
//
import { ROLES } from '@shared/constants/user';

// Set public and private endpoints.
const ROUTES = {
  public: { // These routes can be accessed directly.
    login: '/login',
    accountActivate: '/account-activate',
    forgotPassword: '/forgot-password',
    newPassword: '/new-password',
    qrCode: '/qrcode'
  },
  private: { // Must authenticate before accessing these routes.  Corresponding to the left navigation panel.
    staff: '/staff',
    profile: '/profile',
    orders: '/orders',
    customers: '/customers',
    assets: '/assets',
    platforms: '/platforms',
    jobRequests: '/job-requests',
    vendors: '/v', // Vendors
    dashboard: '/dashboard',
    dataManagement: '/data-management',  // = Import & Export
    clusters: '/clusters',
    map: '/map',  
    sheets: '/sheets',  // = Grid
    measure: '/measure',  // = Lattice Measurements
    windarea: '/windarea',  // = Wind Area
    alarms: '/alarms',
    template: '/template' // template for testing/adding new route.
  },
  initial: '/'
};

export default ROUTES;

// Set which roles can access a certain route.
export const ACCESS = {
  staff: [ROLES.projectManager],
  customers: [ROLES.projectManager, ROLES.customerUser],
  assets: [ROLES.projectManager, ROLES.customerUser],
  profile: Object.values(ROLES),
  orders: [ROLES.techSupport],
  dashboard: [ROLES.projectManager],
  dataManagement: [ROLES.projectManager, ROLES.customerUser],
  platforms: [ROLES.projectManager],
  jobRequests: [ROLES.projectManager, ROLES.pilot, ROLES.observer, ROLES.postProcessingTechnician, ROLES.productionTechnician],
  vendors: [ROLES.projectManager],
  clusters: [ROLES.projectManager, ROLES.postProcessingTechnician],
  map: [ROLES.projectManager, ROLES.pilot, ROLES.observer, ROLES.postProcessingTechnician, ROLES.productionTechnician, ROLES.customerUser],
  sheets: [ROLES.projectManager, ROLES.pilot, ROLES.observer, ROLES.postProcessingTechnician, ROLES.productionTechnician, ROLES.customerUser],
  alarms: [ROLES.projectManager, ROLES.pilot, ROLES.observer, ROLES.postProcessingTechnician, ROLES.productionTechnician],
  //iTwinsStorage: [ROLES.projectManager, ROLES.pilot, ROLES.observer, ROLES.postProcessingTechnician, ROLES.productionTechnician],
  template: [ROLES.projectManager]  // Testing/new stuff should be accessible to projectManager only.
};